import {
  MascheraDispositivo,
  ProprietaMisurataType,
  RegistriMode,
  RegistroDto,
  SogliaCheckType,
  UpdateRegistroDto,
} from "@/api";
import { _mascheraDispositivoData } from "./mascheraDispositivoUtilsData";
import {
  EditorRegistriGFLTFL700,
  formGFLTFL700ToRegistri,
  registriGFLTFL700ToForm,
} from "@/components/RegistriDispositivoDialog/dispositivi/GFLTFL700";
import {
  EditorRegistri_GFL_MONITORING_WTP,
  formToRegistri_GFL_MONITORING_WTP,
  registriToForm_GFL_MONITORING_WTP,
} from "@/components/RegistriDispositivoDialog/dispositivi/GFL_MONITORING_WTP";
import {
  EditorRegistri_GFL_MONITORING_WT,
  formToRegistri_GFL_MONITORING_WT,
  registriToForm_GFL_MONITORING_WT,
} from "@/components/RegistriDispositivoDialog/dispositivi/GFL_MONITORING_WT";
import {
  EditorRegistri_GFL_SENSOR_WT,
  formToRegistri_GFL_SENSOR_WT,
  registriToForm_GFL_SENSOR_WT,
} from "@/components/RegistriDispositivoDialog/dispositivi/GFL_SENSOR_WT";
import { ResetOnlyButtons } from "@/components/DispositivoDetails/buttons/ResetOnlyButtons";
import { StartStopResetButtons } from "@/components/DispositivoDetails/buttons/StartStopResetButtons";

export interface MascheraDispositivoHelper<Data = Record<string, any>> {
  maschera: MascheraDispositivo;
  registroAlertBindings: RegistroAlertBinding[];

  MascheraComponent: any;
  ButtonsComponent: any;
  registriToForm: (registri: RegistroDto[]) => Data;
  formToRegistri: (registri: Data) => UpdateRegistroDto[];
  mode: RegistriMode;
}

export type RegistroAlertBinding = {
  proprietaMisurataType: ProprietaMisurataType;
  alertType: "soglia1" | "soglia2";
  sogliaCheckType: SogliaCheckType;
  registro: string;
};

const mascheraDispositivoHelpers: {
  [m in MascheraDispositivo]: MascheraDispositivoHelper;
} = {
  GFL_TFL_700: generateHelper(_mascheraDispositivoData.GFL_TFL_700),
  GFL_MONITORING_WTP: generateHelper(
    _mascheraDispositivoData.GFL_MONITORING_WTP
  ),
  GFL_MONITORING_WT: generateHelper(_mascheraDispositivoData.GFL_MONITORING_WT),
  GFL_SENSOR_WT: generateHelper(_mascheraDispositivoData.GFL_SENSOR_WT),
} as const;

export function getMascheraDispositivoHelper(
  maschera: MascheraDispositivo
): MascheraDispositivoHelper | null {
  const h = mascheraDispositivoHelpers[maschera];
  if (!h) {
    console.error("[MascheraDispositivoHelper] Unknown maschera: " + maschera);
  }
  return h || null;
}

// -------------------------------------------------
// -------------------------------------------------
// -------------------------------------------------

function generateHelper(
  m: (typeof _mascheraDispositivoData)[keyof typeof _mascheraDispositivoData]
): MascheraDispositivoHelper {
  const base: Partial<MascheraDispositivoHelper> = {
    maschera: m.Maschera,
    registroAlertBindings: m.RegistroAlertBindings.map((b) => {
      return {
        alertType: b.AlertType,
        proprietaMisurataType: b.ProprietaMisurataType,
        registro: b.Registro,
        sogliaCheckType: b.SogliaCheckType,
      };
    }),
  };

  if (m.Maschera === "GFL_TFL_700") {
    base.ButtonsComponent = StartStopResetButtons;
    base.MascheraComponent = EditorRegistriGFLTFL700;
    base.registriToForm = registriGFLTFL700ToForm;
    base.formToRegistri = formGFLTFL700ToRegistri;
    base.mode = "ManyTopics";
  } else if (m.Maschera === "GFL_MONITORING_WTP") {
    base.ButtonsComponent = ResetOnlyButtons;
    base.MascheraComponent = EditorRegistri_GFL_MONITORING_WTP;
    base.registriToForm = registriToForm_GFL_MONITORING_WTP;
    base.formToRegistri = formToRegistri_GFL_MONITORING_WTP;
    base.mode = "SingleJsonMessage";
  } else if (m.Maschera === "GFL_MONITORING_WT") {
    base.ButtonsComponent = ResetOnlyButtons;
    base.MascheraComponent = EditorRegistri_GFL_MONITORING_WT;
    base.registriToForm = registriToForm_GFL_MONITORING_WT;
    base.formToRegistri = formToRegistri_GFL_MONITORING_WT;
    base.mode = "SingleJsonMessage";
  } else if (m.Maschera === "GFL_SENSOR_WT") {
    base.ButtonsComponent = ResetOnlyButtons;
    base.MascheraComponent = EditorRegistri_GFL_SENSOR_WT;
    base.registriToForm = registriToForm_GFL_SENSOR_WT;
    base.formToRegistri = formToRegistri_GFL_SENSOR_WT;
    base.mode = "SingleJsonMessage";
  }

  return base as MascheraDispositivoHelper;
}
